export default "__VITE_ASSET__B5SybbP2__"